import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import StmtDetailPane from "@/views/statement/components/stmtDetailPane";
import { REPOSITORY_OPTIONS } from "@/views/statement/config.js";

export default {
    name: "FormOptBar",
    components: {
        Select,
        Search,
        StmtDetailPane
    },
    data() {
        return {
            repository: null,
            stmtType: "",
            keyword: ""
        };
    },
    computed: {
        repositoryOptions() {
            return REPOSITORY_OPTIONS;
        },
        typeOptions() {
            return this.$store.state.statement.statementType.stmtTypeList.map(type => ({
                label: type.name,
                value: type.id
            }));
        },
        initialData() {
            return {
                repository: this.repository,
                language: this.$store.state.statement.statementType.curLanguage,
                type_id: this.$store.state.statement.statementType.selectedType
            };
        }
    },
    watch: {
        repository() {
            this.$emit("repositorySelect", this.repository);
        },
        stmtType() {
            this.$emit("typeSelect", this.stmtType);
        },
        keyword() {
            this.$emit("stmtSearch", this.keyword);
        }
    }
};
